import { createSelector } from '@reduxjs/toolkit';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSelector } from 'src/selectors/project';

export const projectFileUploadSelector = memoizeSelectorFactory(
  (projectId: string, fileUploadId: string | undefined) =>
    createSelector(
      projectSelector(projectId),
      (project) =>
        (fileUploadId && project?.fileUploadsById[fileUploadId]) || null
    )
);
